import axios from "axios";

//IMPORT API ROUTE URL
import { UPDATE_PROFILE_BASIC_INFO_V2 } from "./apiRoutes";

const updateProfileBasicInfoV2 = (data) => {
  var postData = new FormData();

  postData.append("current_user_slug", data.current_user_slug);
  postData.append("user_slug", data.userSlug);
  postData.append("first_name", data.firstName);
  postData.append("last_name", data.lastName);
  postData.append("user_profile_role", data.jobRole);

  return axios
    .post(UPDATE_PROFILE_BASIC_INFO_V2, postData)
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      return false;
    });
};

export default updateProfileBasicInfoV2;
